// frontend/src/hooks/useDataTheme.js
//
// The active theme, read off <html data-theme="…"> (see useRootAttribute).
// The toggle button's icon-swap CSS targets [data-theme="…"] directly, but the
// toggle's label (useThemeToggle) and the phone's Sun/Moon icon are rendered,
// and those reads must not wait for userContext.user.theme_mode to catch up.

import useRootAttribute from './useRootAttribute';

export default function useDataTheme() {
  return useRootAttribute('data-theme') || 'light';
}
